import gql from 'graphql-tag'

export const fetchCartQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    outlet_details {
      payer_name
      outlet_name
      street
      city
      country
      province
      postalcode
      sap_id
    }
    payer_details {
      payername
      street
      city
      country
      zipcode
      sap_id
      identification_no
      taxvat
    }
    progress_bar_data {
      isFullTruck
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      iMaximumOrderCash
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iTotalCartHectolitres
    }
    id
    email
    total_quantity
    ship_to_id
    grand_total_your_price_details
    items {
      id
      uid
      
      prices {
        price_list {
          total_your_price
          total_your_price_tax
        }
        price {
          value
        }
        row_total {
          value
        }
      }
      product {
        id
        name
        catalog_product_name
        sku
        url_key
        material_type
        packaging_enable
        number_of_bottles_gabbie
        number_of_items_in_box
        number_of_items_on_pallet
        number_of_products_on_layer
        number_of_layers_per_pallet
        product_reco_tags {
          value
          label
          color
        }
        image {
          url
        }
        __typename
      }
      quantity
      quantity_total
      number_of_packages
      number_of_layer
      number_of_layer_total
      number_of_pallet
      number_of_layer_from_fe
      quantity_from_fe
      pack_format
    }
    prices {
      grand_total {
        value
      }
    }
  }
}
`)
